import React, { useEffect, useState } from "react";
import PatientList from "../../components/patient/PatientList";
import { errorMessage } from "../../utils/notificationUtils";
import { fetchPatientsPL } from "../../apis/patientService";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { Pagination } from "antd";
import dayjs from "dayjs";
import { fetchAllSchemesOnBoard } from "../../models/schemeSlice";
import { getAllVisitStages } from "../../models/patientSlice";
import { useParams } from "react-router-dom";

const PatientListContainer = () => {
  const { stage } = useParams();
  const [allPatients, setAllPatients] = useState<any>([]);
  const [visitType, setVisitType] = useState<any>(null);
  const [scheme, setScheme] = useState<any>(null);
  const [search, setSearch] = useState<any>("");
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [pageSize, setPageSize] = useState<any>(50);
  const [totalPatients, setTotalPatients] = useState<any>(null);
  const {
    hospital: selectedHospital,
    auth,
    scheme: allSchemes,
    patients,
  } = useSelector((state: RootState) => state);
  const [dateRange, setDateRange] = useState<any>("today");
  const dispatch = useDispatch<AppDispatch>();
  const [isFetchingPatients, setIsFetchingPatients] = useState<boolean>(false);
  const [isPreAuthSelected, setIsPreAuthSelected] = useState<boolean>(() => stage?.toLowerCase() === "preauth");

  useEffect(() => {
    dispatch(getAllVisitStages());
  }, []);

  useEffect(() => {
    setIsPreAuthSelected(stage?.toLowerCase() === "preauth");
  }, [stage]);

  const getDateRange = (val: string) => {
    const today = dayjs();

    switch (val) {
      case "today":
        return {
          startDate: today.format("DD-MM-YYYY"),
          endDate: today.format("DD-MM-YYYY"),
        };

      case "yesterday":
        const yesterday = today.subtract(1, "day");
        return {
          startDate: yesterday.format("DD-MM-YYYY"),
          endDate: yesterday.format("DD-MM-YYYY"),
        };

      case "last7days":
        return {
          startDate: today.subtract(6, "day").format("DD-MM-YYYY"),
          endDate: today.format("DD-MM-YYYY"),
        };

      default:
        return {
          startDate: today.format("DD-MM-YYYY"),
          endDate: today.format("DD-MM-YYYY"),
        };
    }
  };

  const fetchPatients = async () => {
    try {
      const { startDate, endDate } = getDateRange(dateRange);
      if (selectedHospital?.selectedHospital?.value) {
        setIsFetchingPatients(true);
        const res = await fetchPatientsPL(
          {
            orderBy: "DESC",
            pageNumber: (currentPage - 1)?.toString(),
            pageSize: pageSize.toString(),
            searchTerm: search ? search : null,
            scheme: scheme ? scheme : null,
            visitType: visitType ? visitType : undefined,
            healthCareId: selectedHospital?.selectedHospital?.value,
            endDate: endDate,
            startDate: startDate,
            all:
              Number(selectedHospital?.selectedHospital?.value) === -1
                ? "yes"
                : "no",
          },
          selectedHospital?.selectedHospital?.value,
        );

        setTotalPatients(res?.totalElements);
        setAllPatients(res?.patientResponseList || []);
      }
    } catch (err) {
      //   errorMessage("Please, Try in sometime");
    } finally {
      setIsFetchingPatients(false);
    }
  };

  const fetchPatientsPending = async (stageId: any) => {
    try {
      const { startDate, endDate } = getDateRange(dateRange);
      if (selectedHospital?.selectedHospital?.value) {
        setIsFetchingPatients(true);
        const res = await fetchPatientsPL(
          {
            orderBy: "DESC",
            pageNumber: (currentPage - 1)?.toString(),
            pageSize: pageSize.toString(),
            searchTerm: search ? search : null,
            scheme: scheme ? scheme : null,
            visitType: visitType ? visitType : undefined,
            healthCareId: selectedHospital?.selectedHospital?.value,
            endDate: endDate,
            startDate: startDate,
            all:
              Number(selectedHospital?.selectedHospital?.value) === -1
                ? "yes"
                : "no",
            pending: true,
            stage: stageId,
          },
          selectedHospital?.selectedHospital?.value,
        );

        setTotalPatients(res?.totalElements);
        setAllPatients(res?.patientResponseList || []);
      }
    } catch (err) {
      //   errorMessage("Please, Try in sometime");
    } finally {
      setIsFetchingPatients(false);
    }
  };

  useEffect(() => {
    if (isPreAuthSelected && patients?.visitStages["PreAuth"]?.id) {
      fetchPatientsPending(patients?.visitStages["PreAuth"]?.id);
    }
  }, [isPreAuthSelected, patients?.visitStages]);

  const onShowSizeChange = (current: number, newPageSize: number) => {
    setPageSize(newPageSize);
  };

  useEffect(() => {
    if (!isPreAuthSelected) {
      fetchPatients();
    }
  }, [selectedHospital?.selectedHospital?.value, currentPage, pageSize, isPreAuthSelected]);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (selectedHospital?.selectedHospital?.value) {
      dispatch(
        fetchAllSchemesOnBoard({
          accessToken: auth.accessToken || "",
          healthCareId: selectedHospital?.selectedHospital?.value,
        }),
      );
    }
  }, [selectedHospital?.selectedHospital?.value]);

  return (
    <div>
      <PatientList
        allPatients={allPatients}
        visitType={visitType}
        scheme={scheme}
        search={search}
        dateRange={dateRange}
        setVisitType={setVisitType}
        setScheme={setScheme}
        setSearch={setSearch}
        setDateRange={setDateRange}
        schemes={allSchemes?.schemeOnBoarding || []}
        fetchPatients={fetchPatients}
        isFetchingPatients={isFetchingPatients}
        isPreAuthSelected={isPreAuthSelected}
        setIsPreAuthSelected={setIsPreAuthSelected}
        fetchPatientsPending={fetchPatientsPending}
      />
      <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
        <Pagination
          size="small"
          onChange={handlePageChange}
          showSizeChanger
          style={{ marginTop: "1em" }}
          current={currentPage}
          total={totalPatients}
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={["10", "20", "50", "100"]}
          defaultPageSize={10}
          pageSize={pageSize}
        />
      </div>
    </div>
  );
};

export default PatientListContainer;
